module.exports = __webpack_public_path__ + "static/img/Alanna-Kennedy.92b0b5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alanna-Kennedy.jpg
// module id = OydV
// module chunks = 0